var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcShared = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 104,
  height: 104
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M69 28H35c-6.075 0-11 4.925-11 11v26c0 6.075 4.925 11 11 11h34c6.075 0 11-4.925 11-11V39c0-6.075-4.925-11-11-11m-34-4c-8.284 0-15 6.716-15 15v26c0 8.284 6.716 15 15 15h34c8.284 0 15-6.716 15-15V39c0-8.284-6.716-15-15-15z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M52 43a2 2 0 0 1 2 2v14a2 2 0 1 1-4 0V45a2 2 0 0 1 2-2",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M50.586 43.586a2 2 0 0 1 2.828 0l7 7a2 2 0 1 1-2.828 2.828L52 47.828l-5.586 5.586a2 2 0 1 1-2.828-2.828z",
  clipRule: "evenodd"
})));
export default SvgIcShared;